
import React from 'react'
import Banner from '../home/banner/banner'
import Footer from '../footer/footer'
import DocumentMeta from 'react-document-meta';
require('./details.scss')

import { Get, wrapResponse } from './../../requst'

export default class Details extends React.Component {
    static async getInitialProps(ctx) {
        const [details, detailsBigImg] = await Promise.all([
            wrapResponse(Get({ url: 'news/newsDetail', data: { id: ctx.query.id, category: ctx.req.query.cate_id } })),
            wrapResponse(Get({ url: 'news/banner' })),
        ])

        const footerProps = await Footer.getInitialProps()
        return { details, detailsBigImg, footerProps }
    }


    constructor(props, context) {
        super(props, context);
        this.state = {
            details: false
        }
    }


    recCase() {
        return this.props.details.recCase.map((item, index) => (
            <a href={`/casedetails/${item.id}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} key={index}>
                <img className="Img" src={item.thumb} alt="" />
                <div className="TextBox">
                    <p>
                        {item.title}
                    </p>
                    {/*<p>
                        小程序案例
                    </p>*/}
                </div>
                <div className="Line"></div>
                <div className="Mask"></div>
                <div style={{ display: 'none' }}><a href={`/casedetails/${item.id}`}>{item.title}</a></div>
            </a>
        ))
    }
    recNews() {
        return this.props.details.recNews.map((item, index) => (
            <a href={`/details/${item.id}`}>
                <div className="ImgBox">
                    <img className="Img" src={item.thumb} alt="" />
                </div>
                <p className="P_Con P_Head">{item.title}</p>
                <p className="P_Con P_Text">{item.desc}</p>
                {/*<p className = "P_Con P_Text">我想做个app 多长时间，我想做个app 多长时间，我想做个app 多长时间。</p>*/}
                <div className="Mask_DeatilsBtm"></div>
                <div className="Triangle"></div>
                <div className="MaskText">
                    <p>2019-01</p>
                    <p>02</p>
                    <img src={require('../../assets/common/images/anniujiantou-bai.png')} alt="" />
                </div>
                <div style={{ display: 'none' }}><a href={`/details/${item.id}`}>{item.title}</a></div>
            </a>
        ))
    }

    render() {
        // seo_title seo_keywords seo_description
        if (this.props.details) {
            (this.props.details)
            const meta = {
                title: this.props.details.news.seo_title,
                description: this.props.details.news.seo_description,
                // link: {
                //   rel: {
                //     canonical: 'http://example.com/path/to/sub-page'
                //   }
                // },
                meta: {
                    charSet: 'utf-8',
                    name: {
                        keywords: this.props.details.news.seo_keywords
                    },
                },
                extend: true
            };
            return (
                <DocumentMeta {...meta}>
                    <div>
                        <div style={{ width: '100%', height: '630px', display: 'flex', justifyContent: 'center' }}>
                            <img src={this.props.detailsBigImg ? this.props.detailsBigImg[0].photos : null} style={{ height: '100%' }} alt="" />
                        </div>
                        <div className="DetailsContainer">
                            <div className="DetailsBox">
                                <div className="DetailsTitle">
                                    <img className="fl" src={require('../../assets/common/images/weizhi@2x.png')} alt="" />
                                    <p className="fl" >新闻资讯 > <span>APP开发</span></p>
                                </div>
                                <div className="DetailsLift fl">
                                    <p className="P_one P_Con">{this.props.details ? this.props.details.news.title : null}</p>
                                    <p className="P_two P_Con">{this.props.details ? this.props.details.news.created_at : null}</p>
                                    <p className="P_three P_Con"></p>
                                    <div className="P_four P_Con" dangerouslySetInnerHTML={{ __html: this.props.details.news.content }}></div>

                                </div>
                                <ul className="DetailsRight fr">
                                    <p className="RightHead">案例展示</p>
                                    {this.props.details.recCase ? this.recCase() : null}
                                </ul>
                                <div className="clear"></div>
                                <p className="ButtomTitle">相关推荐</p>
                                <ul className="DeatilsButtom ">

                                    {this.props.details.recNews ? this.recNews() : null}
                                </ul>
                            </div>
                        </div>
                        <Footer {...this.props.footerProps} />
                    </div>
                </DocumentMeta>

            )
        } else {
            return null
        }
    }
}